import styled, { css } from 'styled-components'

import type { FontType } from './types/FontType'

type ParagraphProps = {
  color?: string
  textAlign?: 'left' | 'center' | 'right'
  type: FontType
  textDecoration?: 'overline' | 'underline' | 'line-through' | 'none'
}

const defaultBodyStyles = css<ParagraphProps>`
  ${({ color, textAlign, textDecoration }) => {
    return `
      color: ${color || 'inherit'};
      text-align: ${textAlign || 'inherit'};
      text-decoration: ${textDecoration || 'none'};
    `
  }}
`

const P = styled.p<ParagraphProps>`
  ${defaultBodyStyles}
  ${({ theme, type }) => theme.Typography[type]}

  display: block;
  margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space4};
`

const Span = styled.span<ParagraphProps>`
  ${defaultBodyStyles}
  ${({ theme, type }) => theme.Typography[type]}

  a {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`

const Li = styled.li<ParagraphProps>`
  ${defaultBodyStyles}
  ${({ theme, type }) => theme.Typography[type]}

  display: list-item;
  margin-bottom: ${({ theme }) => theme.UI.SpacingPx.Space4};
`

export { Li, P, Span }
